(function (angular) {
    'use strict';

    angular.module('app')
        .controller('memberPackagesController', memberPackagesController);

    memberPackagesController.$inject = [
        'memberPackagesPayload',
        'MemberPackagesApi',
        '$scope',
        'Helpers',
    ];

    function memberPackagesController(
        memberPackagesPayload,
        MemberPackagesApi,
        $scope,
        Helpers,
    ) {
        var vm = this;
        vm.limit = 6;

        const nowISO = window.moment().format(Helpers.isoFormat);


        // Properties
        vm.packages = angular.copy(memberPackagesPayload);
        vm.packages.data = [];
        vm.filters = {
            hidden: false,
            page: 1
        };
        vm.isLoading = false;

        // Methods
        vm.getPackages = getPackages;

        // create a new connect resource for each one
        angular.forEach(memberPackagesPayload.data, function (pkg) {
            vm.packages.data.push(new MemberPackagesApi(pkg).transform());
        });

        /**
         * Get the member packages from the API.
         *
         * @return {void}
         */
        function getPackages() {
            vm.isLoading = true;

            MemberPackagesApi.get(vm.filters, function (response) {
                vm.isLoading = false;
                vm.packages = response;
            });
        }
        $scope.loadMore = function() {
            var increamented = vm.limit + 3;
            vm.limit = increamented > vm.packages.length ? vm.packages.length : increamented;
          };

    }

}(angular));